import { Divider, IconButton, Stack, Tooltip } from "@mui/material";
import React, { useState } from "react";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialBox from "../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../components/MaterialInput";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import Swal from "sweetalert2";
import PostAddIcon from "@mui/icons-material/PostAdd";
import ClearIcon from "@mui/icons-material/Clear";

const TravelDocuments = ({
  travelDocuments,
  setTravelDocuments,
  inputDisbled,
  formtype,
}) => {
  const showAlert = (title, name, i, inputname) => {
    let travelDocumentsData = { ...travelDocuments };
    Swal.fire({
      title: `Enter your ${title} Notes`,
      input: "textarea",
      inputValue: name,
      inputPlaceholder: "Type your message here...",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      showConfirmButton: !inputDisbled,
      showCancelButton: true,
      confirmButtonText: "Submit",
      didOpen: () => {
        const textarea = Swal.getInput();
        if (textarea) {
          textarea.oninput = (event) => handleTravelChange(event, i, inputname);
        }
      },
      preConfirm: () => {
        const updatedValue = Swal.getInput().value;
        if (!updatedValue.trim()) {
          Swal.showValidationMessage("Please enter some text!");
          return false;
        }
        return updatedValue;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Submitted!", `Your message: ${result.value}`, "success");
      }
    });
  };
  const [rowDisabled, setRowDisabled] = useState({});

  const addrow = (index) => {
    setTravelDocuments([
      ...travelDocuments,
      {
        documentSubmissionMail: "",
        documentComments: "",
        medicalTestApplied: "",
        medicalTestAppliedComments: "",
        medicalTestReport: "",
        medicalTestReportComments: "",
        biometric: "",
        biometricComments: "",
        documentSubmission: "",
        documentSubmissionComments: "",
        documentReturned: "",
        documentReturnedComments: "",
        visaStamped: "",
        visaStampedComments: "",
        reachedOnSite: "",
        reachedOnSiteComments: "",
        visaExpiryDays: "",
        visaExpiryDate: "",
        visaExpiryComments: "",
        startFromOnsite: "",
        startFromOnsiteComments: "",
        returnedToCountry: "",
        returnedToCountryComments: "",
        formIsopen: true,
      },
    ]);
    // setRowDisabled((prev) => ({ ...prev, [index]: true }));
  };

  const handleClose = (i) => {
    setTravelDocuments((prevDocs) => {
      const updatedDocs = [...prevDocs];
      updatedDocs.splice(i, 1);
      return updatedDocs;
    });
    setRowDisabled((prev) => ({ ...prev, [i]: true }));
  };
  function addDaysToDate(inputDate, daysToAdd) {
    let dateParts = inputDate?.split("-");
    let date = new Date(Date.UTC(dateParts[0], dateParts[1] - 1, dateParts[2]));

    date.setUTCDate(date.getUTCDate() + daysToAdd);

    let year = date.getUTCFullYear();
    let month = String(date.getUTCMonth() + 1).padStart(2, "0");
    let day = String(date.getUTCDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const handleTravelChange = (e, i, name) => {
    const value = e?.target?.value;

    const temp = [...travelDocuments];
    if (name == "reachedOnSite") {
      temp[i]["visaExpiryDays"] = "";
      temp[i]["visaExpiryDate"] = "";
    }
    if (name == "visaExpiryDays") {
      if (value == "") {
        temp[i]["visaExpiryDate"] = "";
        temp[i]["visaExpiryDaysStatus"] = "unchecked";
      } else {
        // const numberLengthRegex = new RegExp("^(3[0-9]|[4-9][0-9]|[1-2][0-9]{2}|365)$")
        // if (numberLengthRegex.test(value) === true) {
        //   temp[i][name + "Status"] =
        //     value === undefined ? "unchecked" : "success";
        // } else {
        //   temp[i][name + "Status"] =
        //     temp[i][name] === "" ? "unchecked" : "error";
        // }
        if (value >= 30 && value <= 365) {
          temp[i]["visaExpiryDaysStatus"] = "success";
        } else if (value == "") {
          temp[i]["visaExpiryDaysStatus"] = "unchecked";
        } else {
          temp[i]["visaExpiryDaysStatus"] = "error";
        }
        let newDate = addDaysToDate(
          travelDocuments[i]?.reachedOnSite,
          Number(value)
        );

        temp[i]["visaExpiryDate"] = newDate;
      }
    }

    temp[i][name] = value;

    setTravelDocuments(temp);
  };
  const lastIndex = travelDocuments.length - 1;
  const lastItemHasReturnedToCountry =
    travelDocuments.length > 0 && travelDocuments[lastIndex].returnedToCountry;
  return (
    <>
      <Stack direction="row" spacing={1}>
        <MaterialTypography component="label" variant="body2" fontWeight="bold">
          Travel Documents Details
        </MaterialTypography>
      </Stack>
      {travelDocuments?.map((v, i) => {
        return (
          <MaterialBox key={i}>
            {i != 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  // padding: "0px 30px",
                  paddingRight: "60px",
                }}
              >
                <Tooltip
                  placement="left"
                  onClick={() => handleClose(i)}
                  title={"Delete Travel Document Details"}
                  sx={{ border: "solid 2px" }}
                >
                  <IconButton size="large">
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}

            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                         Documents Submission via mail
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="documentSubmissionMail"
                      type="date"
                      value={v?.documentSubmissionMail}
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "documentSubmissionMail")
                      }
                      success={v?.documentSubmissionMail ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "Document Submission Mail",
                        v?.documentComments,
                        i,
                        "documentComments"
                      )
                    }
                    title={"Document Submission Mail Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={v?.documentComments && { color: "#66d432" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                         Medical Test Applied
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="medicalTestApplied"
                      value={v?.medicalTestApplied}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "medicalTestApplied")
                      }
                      success={v?.medicalTestApplied ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "Medical Test Applied",
                        v?.medicalTestAppliedComments,
                        i,
                        "medicalTestAppliedComments"
                      )
                    }
                    title={"Medical Test Applied Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={
                          v?.medicalTestAppliedComments && { color: "#66d432" }
                        }
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                         Medical Test
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="medicalTestReport"
                      value={v?.medicalTestReport}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "medicalTestReport")
                      }
                      success={v?.medicalTestReport ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "Medical Test Report",
                        v?.medicalTestReportComments,
                        i,
                        "medicalTestReportComments"
                      )
                    }
                    title={"Medical Test Reports Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={
                          v?.medicalTestReportComments && { color: "#66d432" }
                        }
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Biometrics
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="biometric"
                      value={v?.biometric}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) => handleTravelChange(e, i, "biometric")}
                      success={v?.biometric ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "Biometric",
                        v?.biometricComments,
                        i,
                        "biometricComments"
                      )
                    }
                    title={"Biometric Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={v?.biometricComments && { color: "#66d432" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                         Documents Submission
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="documentSubmission"
                      value={v?.documentSubmission}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "documentSubmission")
                      }
                      success={v?.documentSubmission ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "documentSubmission",
                        v?.documentSubmissionComments,
                        i,
                        "documentSubmissionComments"
                      )
                    }
                    title={"Document Submission Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={
                          v?.documentSubmissionComments && { color: "#66d432" }
                        }
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Documents Returned
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="documentReturned"
                      value={v?.documentReturned}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "documentReturned")
                      }
                      success={v?.documentReturned ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "documentReturned",
                        v?.documentReturnedComments,
                        i,
                        "documentReturnedComments"
                      )
                    }
                    title={"Document Returned Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={v?.documentReturnedComments && { color: "#66d432" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Visa Stamped Date
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="visaStamped"
                      value={v?.visaStamped}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) => handleTravelChange(e, i, "visaStamped")}
                      success={v?.visaStamped ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "visaStamped",
                        v?.visaStampedComments,
                        i,
                        "visaStampedComments"
                      )
                    }
                    title={"Visa Stamped Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={v?.visaStampedComments && { color: "#66d432" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Started from India
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="startFromIndia"
                      value={v?.startFromIndia}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "startFromIndia")
                      }
                      success={v?.startFromIndia ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "startFromIndia",
                        v?.startFromIndiaComments,
                        i,
                        "startFromIndiaComments"
                      )
                    }
                    title={"Started from India Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={v?.startFromIndiaComments && { color: "#66d432" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Reached OnSite
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="reachedOnSite"
                      value={v?.reachedOnSite}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "reachedOnSite")
                      }
                      success={v?.reachedOnSite ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "reachedOnSite",
                        v?.reachedOnSiteComments,
                        i,
                        "reachedOnSiteComments"
                      )
                    }
                    title={"Reached OnSite Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={v?.reachedOnSiteComments && { color: "#66d432" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Visa Expiry Days
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialBox>
                      <MaterialInput
                        name="visaExpiryDays"
                        value={v?.visaExpiryDays}
                        type="number"
                        placeholder="Enter Visa Expiry Days"
                        onChange={(e) => {
                          const value = e?.target?.value;

                          if ((value >= 1 && value <= 365) || value == "") {
                            handleTravelChange(e, i, "visaExpiryDays");
                          }
                        }}
                        // disabled={v?.reachedOnSite ? false : formtype !="view" ? true:}
                        disabled={
                          formtype == "view"
                            ? true
                            : v?.reachedOnSite
                            ? false
                            : true
                        }
                        // success={v?.visaExpiryDays ? true : false}
                        success={v?.visaExpiryDaysStatus === "success"}
                        error={v?.visaExpiryDaysStatus === "error"}
                      />
                      {v?.visaExpiryDaysStatus === "error" && (
                        <p
                          style={{
                            fontSize: "11px",
                            marginTop: "5px",
                            color: "red",
                            fontWeight: "600",
                          }}
                        >
                          Visa expiry days must be between 30 to 365 days only
                        </p>
                      )}
                    </MaterialBox>
                  </MaterialBox>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Visa Expiry Date
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="visaExpiryDate"
                      value={v?.visaExpiryDate}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "visaExpiryDate")
                      }
                      success={v?.visaExpiryDate ? true : false}
                      disabled={true}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "visaExpiryDate",
                        v?.visaExpiryComments,
                        i,
                        "visaExpiryComments"
                      )
                    }
                    title={"Visa ExpiryDate Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={v?.visaExpiryComments && { color: "#66d432" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Start From Onsite
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="startFromOnsite"
                      value={v?.startFromOnsite}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "startFromOnsite")
                      }
                      success={v?.startFromOnsite ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "startFromOnsite",
                        v?.startFromOnsiteComments,
                        i,
                        "startFromOnsiteComments"
                      )
                    }
                    title={"Start FromOnsite Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={v?.startFromOnsiteComments && { color: "#66d432" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <MaterialBox>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Returned to India
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="returnedToCountry"
                      value={v?.returnedToCountry}
                      type="date"
                      placeholder="Enter Employee Name"
                      onChange={(e) =>
                        handleTravelChange(e, i, "returnedToCountry")
                      }
                      success={v?.returnedToCountry ? true : false}
                      disabled={inputDisbled}
                    />
                  </MaterialBox>
                  <Tooltip
                    onClick={() =>
                      showAlert(
                        "returnedToCountry",
                        v?.returnedToCountryComments,
                        i,
                        "returnedToCountryComments"
                      )
                    }
                    title={"Returned To Country Notes"}
                  >
                    <IconButton>
                      <SpeakerNotesIcon
                        sx={
                          v?.returnedToCountryComments && { color: "#66d432" }
                        }
                      />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
            </Grid>
            {i == lastIndex && v?.returnedToCountry && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  paddingRight: "60px",
                  marginTop: "-40px",
                }}
              >
                <Tooltip
                  onClick={() => addrow()}
                  title={"Add Travel Document Details"}
                  sx={{
                    border: "solid 2px",
                  }}
                  placement="left"
                >
                  <IconButton size="large">
                    <PostAddIcon />
                  </IconButton>
                </Tooltip>
              </div>
            )}
            <Divider />
          </MaterialBox>
        );
      })}
  
    </>
  );
};

export default TravelDocuments;
